import React from 'react'

// Components
import { ContainerCard } from '../../../reusable-components/AgiliteCards'
import CheckinForm from '../../../Booking-Checkin'

const Config = () => {
  return (
    <ContainerCard title='Configurations'>
      <CheckinForm />
    </ContainerCard>
  )
}

export default Config
